export default __webpack_public_path__ + "static/media/PopupIcons_View_Daily_Balance_White.cc1b576d.svg";